import { render } from "./TvmDealerSpecials.vue?vue&type=template&id=ce8dc858&scoped=true"
import script from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"
export * from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"

import "./TvmDealerSpecials.vue?vue&type=style&index=0&id=ce8dc858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8dc858"],['__file',"src/components/ChatWidget/TvmDelaerSpecials/TvmDealerSpecials.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce8dc858"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce8dc858', __exports__)) {
    api.reload('ce8dc858', __exports__)
  }
  
  module.hot.accept("./TvmDealerSpecials.vue?vue&type=template&id=ce8dc858&scoped=true", () => {
    api.rerender('ce8dc858', render)
  })

}


export default __exports__